'use strict';
import {EwSiteApp} from '../../app/ewsiteapp.js';

EwSiteApp.controller('CommentsCtrl', ['$scope', '$http', '$attrs', '$log', function ($scope, $http, $attrs, $log) {
    $scope.postUrl = '';
    $scope.getUrl = '';
    $scope.hash_key = '';
    $scope.isconfirm = false;
    $scope.errors = [];
    $scope.comments = {
        list: []
    };
    $scope.all_displayed = false;
    $scope.gcWidget = null;

    $scope.clearCommentsForm = function () {
        $scope.comment.name = "";
        $scope.comment.email = "";
        $scope.comment.comment = "";
        $scope.comment.grecaptcha = null;
        $scope.errors = [];
        $scope.commentform.$setPristine();
    };

    $scope.submit = function () {
        if ($scope.gcWidget && window.grecaptcha) {
            var gc_response = window.grecaptcha.getResponse($scope.gcWidget);
            if (gc_response) {
                $scope.comment.grecaptcha = gc_response;
                gc_response = null;
            } else {
                window.grecaptcha.execute($scope.gcWidget).then(function (token) {
                    $scope.comment.grecaptcha = token;
                    $scope.submitForm();
                }).catch(function (error) {
                    console.error('Error executing reCAPTCHA:', error);
                    $scope.loading = false;
                });
                return;
            }
        } else {
            console.log('No valid reCAPTCHA site key available, skipping reCAPTCHA check.');
        }

        $scope.submitForm();
    };

    $scope.submitForm = function () {
        if ($scope.comment.grecaptcha && $scope.postUrl !== '') {
            $scope.isconfirm = false;
            $http({
                method: 'POST',
                url: $scope.postUrl + '?hash_key=' + $scope.hash_key,
                data: $scope.comment,
                xsrfCookieName: $scope.hash_key
            }).then(function (response) {
                if (response.data.data.success) {
                    $scope.clearCommentsForm();
                    $scope.isconfirm = response.data.data.isconfirm;
                    if (!$scope.isconfirm) {
                        $scope.getList(1);
                    }
                } else if (angular.isDefined(response.data.data.messages)) {
                    $scope.errors = response.data.data.messages;
                }
                if (angular.isDefined(response.data.data.debug)) {
                    $log.debug(response.data.data.debug);
                }
                if (!$scope.isconfirm) {
                    $('html, body').animate({
                        scrollTop: $(".comments__list").offset().top - 10
                    }, 300);
                }
            }, function (response) {
                console.log(['Error', response]);
            });
        }
    };

    $scope.getList = function (getall) {
        if (getall == 1) {
            $scope.all_displayed = true;
        }
        if ($scope.getUrl !== '') {
            $http({
                method: 'GET',
                url: $scope.getUrl + '?getall=' + getall + ';hash_key=' + $scope.hash_key,
            }).then(function (response) {
                $scope.comments.list = response.data.list;
                if (getall == 0 && response.data.totalRows <= $scope.limit) {
                    $scope.all_displayed = true;
                }
            }, function (response) {
                console.log(['Error', response]);
            });
        }
    };

    $scope.hasErrors = function () {
        return $scope.errors.length > 0;
    };

}]).directive('commentsContainer', function () {
    return {
        restrict: 'A',
        link: function (scope, element, attr) {
            scope.postUrl = '';
            scope.getUrl = '';
            scope.hash_key = '';
            scope.limit = 10;
            if (attr.postUrl !== '') {
                scope.postUrl = attr.postUrl;
            }
            if (attr.id !== '') {
                scope.hash_key = attr.id;
            }
            if (attr.limit !== '') {
                scope.limit = attr.limit;
            }
            if (attr.getUrl !== '') {
                scope.getUrl = attr.getUrl;
                scope.getList(0);
            }
        }
    };
}).directive('gRecaptcha', function () {
    return {
        restrict: 'A',
        link: function (scope, element, attr) {
            if (attr.sitekey) {
                window.grecaptcha.ready(function () {
                    scope.gcWidget = grecaptcha.render('recaptcha_comments', {
                        sitekey: attr.sitekey,
                        callback: 'gcAngularRecaptchaResponse',
                        size: 'invisible',
                    });
                });

                window.gcAngularRecaptchaResponse = function (token) {
                    if (token) {
                        scope.submit();
                        window.grecaptcha.reset(scope.gcWidget);
                    }
                };
            } else {
                console.log('No reCAPTCHA sitekey provided or invalid key.');
            }
        }
    };
});
